module.exports = __webpack_public_path__ + "img/binner-5.38ade3bf.jpg";